import { getParamsFromResource } from '../api/request'

/**
 * Парсинг tc_resource.READS_SUBMIT_PERIOD: {"from":25,"to":1}
 * @returns {{from: number, to: number}|null}
 */
export function parseReadsSubmitPeriod(raw) {
    if (!raw) return null

    let period = raw
    if (typeof raw === 'string') {
        try {
            period = JSON.parse(raw)
        } catch {
            return null
        }
    }

    const from = Number(period?.from)
    const to = Number(period?.to)
    if (
        !Number.isInteger(from) ||
        !Number.isInteger(to) ||
        from < 1 ||
        from > 31 ||
        to < 1 ||
        to > 31
    ) {
        return null
    }

    return { from, to }
}

export function isDayInReadsSubmitPeriod(period, day = new Date().getDate()) {
    if (!period) return true
    const { from, to } = period
    return from <= to ? day >= from && day <= to : day >= from || day <= to
}

export function getReadsSubmitPeriodMessage(period, isKazan) {
    if (!period) return ''

    const {from, to} = period
    
    const message = `Передача показаний приборов учета в личном кабинете доступна в период с ${from} числа по ${to} число (включительно) месяца, следующего за расчетным.`;

    if (!isKazan) {
        return message;
    }

    return [
        `Показания интегральных расчётных приборов учета снимаются в период с 23 по последнее число каждого месяца.`,
        message,
        `Предоставленные показания интегральных приборов учета, по договору принимаются по состоянию на 00 часов 00 минут первого дня месяца, следующего за расчетным месяцем.`,
        `Дополнительная информация по <a target="_blank" href="https://tatenergosbyt.ru/b2b/uchet/poryadok-peredachi-pokazanij/#uchet__section">ссылке</a>`
    ].join('\n');
}

/**
 * Напоминание «срок истекает»: последние дни окна подачи.
 * Для окна 25→3 это дни 1..3 (как раньше было захардкожено).
 */
export function isReadsSubmitDeadlineApproaching(period, day = new Date().getDate()) {
    if (!period) return false
    const { from, to } = period
    if (from <= to) {
        const startRemind = Math.max(from, to - 2)
        return day >= startRemind && day <= to
    }
    return day >= 1 && day <= to
}

export async function fetchReadsSubmitPeriod() {
    const res = await getParamsFromResource('READS_SUBMIT_PERIOD')
    if (!res.isOk || !res.data) return null
    return parseReadsSubmitPeriod(res.data)
}
